module.exports = __webpack_public_path__ + "img/DE05723.f1465664.png";